import { useEffect } from 'react';
import Raven from 'raven-js';
import { getActionType } from 'automation-ui-log-events/records/LogEvent/utils';
import DynamicLogEventMessage from 'automation-ui-log-events/components/DynamicLogEventMessage';
import LegacyLogEventMessage from 'automation-ui-log-events/components/LegacyLogEventMessage';
import Metrics from 'automation-ui-log-events/utils/metrics';
import ErrorBoundary from 'automation-ui-core/errors/ErrorBoundary';
import { getHistoryMessage } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LogEventMessage = ({
  flowObjectTypeId,
  logEvent,
  shouldTruncate = false
}) => {
  // Extension action types still use their own parsing mechanisms, which need to be ported over
  // to the BE. See https://hubspot.slack.com/archives/C01B1N75J5C/p1714155114934759
  const isExtensionActionType = getActionType(logEvent) === 'AUTOMATION_EXTENSION';

  // Track metrics and errors
  useEffect(() => {
    if (isExtensionActionType) {
      Metrics.counter('extension-log-event-rendered').increment();
    } else {
      Metrics.counter('built-in-log-event-rendered').increment();
    }
  }, [isExtensionActionType]);
  useEffect(() => {
    if (!isExtensionActionType && !logEvent.logEventMessage) {
      // We should always have a valid log event message for built in actions.
      // We should log to sentry and take a metric if this is the case.
      Raven.captureMessage('Missing log event message for portal', {
        extra: {
          logEvent: logEvent.toJS()
        }
      });
      Metrics.counter('missing-log-event-message').increment();
    }
  }, [logEvent, isExtensionActionType]);
  const ListItemWrap = ({
    children
  }) => shouldTruncate ? /*#__PURE__*/_jsx(TruncateString, {
    children: children
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });

  /**
   * If there is a history message we should use the santization that we have on the FE
   * Otherwise we default to what we get back from the BE
   */
  if (isExtensionActionType && getHistoryMessage(logEvent)) {
    return /*#__PURE__*/_jsx(LegacyLogEventMessage, {
      logEvent: logEvent,
      flowObjectTypeId: flowObjectTypeId,
      shouldTruncate: shouldTruncate
    });
  }
  return /*#__PURE__*/_jsx(ListItemWrap, {
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      boundaryName: "DynamicLogEventMessage_parseDataField",
      renderError: () => /*#__PURE__*/_jsx(LegacyLogEventMessage, {
        logEvent: logEvent,
        flowObjectTypeId: flowObjectTypeId
      }),
      children: /*#__PURE__*/_jsx(DynamicLogEventMessage, {
        logEvent: logEvent
      })
    })
  });
};
export default LogEventMessage;